import { TranslationMap } from '@trimble-gcs/i18n-types';

export function taggingTranslations() {
  return {
    saveError: {
      text: $localize`:@@singleSelectedTagging.saveError:Error saving tag(s). Please try again later.`,
      desc: 'Error message shown when saving tags fails.',
    },
    tagInput: {
      placeholder: {
        text: $localize`:@@singleSelectedTagging.tagInput.placeholder:Begin typing to search...`,
        desc: 'Placeholder text for the tag input field.',
      },
      lengthExceededError: {
        text: $localize`:@@singleSelectedTagging.tagInput.lengthExceededError:Maximum {maxCharacters} characters allowed.`,
        desc: 'Error message shown when the tag input exceeds the maximum character length.',
      },
    },
  } satisfies TranslationMap;
}
